<template>
    <div class="article-home">
        <p>
            West Coast Swing classes in Headingley, Leeds UK. Learn the partner dance trending on social media. Viral
            sensation.
        </p>
        <p>
            <strong>Improvise to any song, any music.</strong>
        </p>
        <p>
            Follow us on <a href="https://www.instagram.com/swingrenegades/">instagram</a>
            to find out what it's all about. Signup to the
            <nuxt-link :to="routeMailingList">mailing list</nuxt-link>
            for the latest class news. Or head to our next event.
        </p>
        <p><strong>Too far away?</strong> Find a class <a href="https://www.affinityswing.com/classes">near you</a>.</p>
    </div>
</template>

<script>
import {mapState} from 'pinia';

export default {
    name: 'ArticleHome',
    computed: {
        ...mapState(useStoreAuth, {
            isLoggedIn: 'isLoggedIn',
        }),
        routeMailingList() {
            if (this.isLoggedIn) return '/me/notifications';
            return '/signup';
        },
    },
};
</script>
